import { INode } from 'shared/types/tree'
import { getSubjectId } from '../components/utility/TreeHelpers'
import { useSubjectsById } from './subjects.atoms'
import { ISubject } from '../components/ingestion/Utility'

export function useSubjectForTree(tree: INode): ISubject | undefined {
  const subjectId = getSubjectId(tree)
  const subjects = useSubjectsById() ?? {}
  if (subjectId && subjectId in subjects) {
    return subjects[subjectId]
  }
}
